export default __webpack_public_path__ + "static/media/room2.2ca08b13.jpg";